"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var Tree_1 = require("../../components/Tree");
var ExcessesTree = /** @class */ (function (_super) {
    __extends(ExcessesTree, _super);
    function ExcessesTree(props) {
        var _this = _super.call(this, props) || this;
        _this.renderExcesses = function (insuredPerson) {
            var excesses = [];
            for (var _i = 0, _a = _this.props.coverage.amounts; _i < _a.length; _i++) {
                var amount = _a[_i];
                var regex = /Excess/g;
                if (regex.test(amount.amountText)) {
                    var finalAmount = amount.amount;
                    if (amount.amountCode === ExcessesTree_1.COMPULSORY_EXCESS_CODE && insuredPerson.excesses && insuredPerson.excesses.adExcess > 0) {
                        finalAmount += insuredPerson.excesses.adExcess;
                    }
                    else if (amount.amountCode === ExcessesTree_1.HOME_EXCESS) {
                        finalAmount = _this.props.interaction.annualHomeExcesses.allOtherClaims;
                    }
                    excesses.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [amount.amountText, " ", (0, commonFunctions_1.getAmountToDisplay)(finalAmount)] }) }, amount.amountText));
                }
            }
            return excesses.length > 0 ? excesses : null;
        };
        _this.getInsuredPersons = function (interaction) {
            var insuredPersons = [interaction.policyHolder];
            if (Array.isArray(interaction.additionalDrivers)) {
                return insuredPersons.concat(interaction.additionalDrivers);
            }
            return insuredPersons;
        };
        return _this;
    }
    ExcessesTree_1 = ExcessesTree;
    ExcessesTree.prototype.render = function () {
        var _this = this;
        return this.getInsuredPersons(this.props.interaction).map(function (insuredPerson) {
            return (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Excesses (".concat(insuredPerson.firstName, " ").concat(insuredPerson.lastName, ")"), children: _this.renderExcesses(insuredPerson) }, insuredPerson.internalId);
        });
    };
    var ExcessesTree_1;
    ExcessesTree.COMPULSORY_EXCESS_CODE = "COMPULSORY_EXCESS";
    ExcessesTree.HOME_EXCESS = "HOME_EXCESS";
    ExcessesTree = ExcessesTree_1 = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], ExcessesTree);
    return ExcessesTree;
}(React.Component));
exports.default = ExcessesTree;
//# sourceMappingURL=ExcessesTree.js.map